import { Inbox } from "@mui/icons-material";
import { Badge, Typography } from "@mui/material";

const EventComponent = ({ event }) => {
  const bgColor = {
    "PE Pending": "#ed6c02",
    "PE Completed": "#4caf50",
    "PE Created": "#0288d1",
  };

  return (
    <div
      style={{
        width: "100",
        height: "32px",
        backgroundColor: bgColor?.[event?.title] || "whitesmoke",
        borderRadius: "5px",
        borderBottom: "1px solid black",
      }}
      className="d-flex align-items-center justify-content-between p-2"
    >
      <div>{event?.title}</div>
      <strong>{event?.count}</strong>
    </div>
  );
};

export default EventComponent;
